import { render, staticRenderFns } from "./OtherLoanApplicationCard.vue?vue&type=template&id=f22ccf5a"
import script from "./OtherLoanApplicationCard.vue?vue&type=script&lang=js"
export * from "./OtherLoanApplicationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports